module.exports = __webpack_public_path__ + "img/slovenia.151bce56.svg";